import EditableTagGroup from './editable-tag-group';

export default EditableTagGroup;